import * as React from 'react';

interface IFretProps {
    readonly active: boolean,
    readonly scale: ReadonlyArray<string>,
    readonly note: string
}

interface IFretState {
    selected: boolean
}

class Fret extends React.Component<IFretProps, IFretState> {

  constructor(props: IFretProps) {
    super(props)
    this.state = {
      selected: false
    }
  }

  public render () {
    return <td className={this.className()} onClick={this.clickHandler}>
      <span>{this.props.note}</span>
      <sub>{this.renderIndex()}</sub>
    </td>
  }

  private clickHandler = () => { 
    this.setState({selected: !this.state.selected})
  }

  private renderIndex () {
    const index = this.props.scale.indexOf(this.props.note)
    if (index > -1 ) {
      return index + 1
    } else {
      return null
    }
  }

  private className () {
    let klass = ''
    if (this.props.active) { klass += 'active ' }
    if (this.state.selected) { klass += 'selected ' }
    return klass
  }  
}

export default Fret



// WEBPACK FOOTER //
// ./src/components/fret/index.tsx